// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__3r643","content":"Page_content__1I5pS","scrollingDisabled":"Page_scrollingDisabled__Sf9BO"};